import { render, staticRenderFns } from "./d-new-follows-activity.vue?vue&type=template&id=0489a165&"
import script from "./d-new-follows-activity.vue?vue&type=script&lang=js&"
export * from "./d-new-follows-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports